import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import ScrollProgress from "../components/common/ScrollProgress";
import WhatsAppButton from "../components/contact/WhatsAppButton"; // Import WhatsApp button

const MainLayout = ({ children }) => {
  return (
    <>
      <ScrollProgress />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton /> {/* Add it here - after Footer but still visible */}
    </>
  );
};

export default MainLayout;